<template>

  <div class="container page">

    <van-nav-bar :title="$t('withdraw.with_record')" class="nav-bar" :border="false">

      <template #left>

        <van-icon name="arrow-left" @click="back()" />

      </template>

    </van-nav-bar>

    <div class="main">

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />

        <div v-else class="record-card" v-for="(v, key) in list" :key="key">

          <div class="card-top">

            <span class="status-text" :class="{ 'is-success': v.status === 2 }">{{ v.status_text }}</span>

            <span class="amount-text">{{ $t('withdraw.money') }}: -{{ v.money }}</span>

          </div>

          <div class="card-line" v-if="v.desc">{{ $t('withdraw.desc') }}：{{ v.desc }}</div>

          <div class="card-line">{{ $t('withdraw.submit_time') }}：{{ v.create_time }}</div>

          <div class="card-line">{{ $t('withdraw.check_time') }}：{{ v.update_time }}</div>

        </div>

      </van-pull-refresh>

    </div>

  </div>

</template>



<script>

export default {

  data() {

    return {

      isLoading: false,

      list: []

    }

  },

  methods: {

    back() {

      window.history.back()

    },

    onRefresh() {

      this.getUserWithdrawList()

    },

    getUserWithdrawList() {

      this.isLoading = true

      this.$http({ method: 'get', url: 'user_get_withdraw_list' }).then(res => {

        this.isLoading = false

        if (res.code === 200) this.list = res.data || []

        else if (res.code === 401) this.$toast(res.msg)

      }).catch(() => { this.isLoading = false })

    }

  },

  created() {

    if (!localStorage.getItem('token')) {

      this.$router.push({ path: '/Login' })

    } else {

      this.getUserWithdrawList()

    }

  }

}

</script>



<style lang="less" scoped>

@import '../../assets/css/base.css';

</style>

